module.exports = __webpack_public_path__ + "static/media/thailand.384707c7.jpeg";